import {
  IAdvancedPriceSettingItem,
  IProductSet,
  IAdvancedPriceSetting,
} from '../type';
import _ from 'lodash';
export const productSetReselectFilter = (
  advancedPriceSettings: IAdvancedPriceSetting<IAdvancedPriceSettingItem>[],
  productSet: IProductSet[],
) => {
  const mapProductSet: { [propName: string]: IProductSet } = _.cloneDeep(
    productSet || [],
  ).reduce((pre, now) => {
    return { ...pre, [now.product.uuid]: now };
  }, {});
  const res: IAdvancedPriceSetting<IAdvancedPriceSettingItem>[] =
    advancedPriceSettings.map((settings) => {
      const { items = [] } = settings;
      const newItems = items.reduce((pre, now) => {
        const { productUuid } = now;
        if (mapProductSet[productUuid]) {
          mapProductSet[productUuid].marked = true;
          return [...pre, now];
        } else {
          return pre;
        }
      }, []);
      return { ...settings, items: newItems };
    });
  const newProducts: IProductSet[] = Object.values(mapProductSet).filter(
    (i: IProductSet) => !i.marked,
  );

  newProducts.forEach((i) => {
    const { noOfUnit, product } = i;
    const { uuid, name } = product;
    res.forEach((item) => {
      const { items } = item;
      items.push({
        unitPrice: 0,
        productUuid: uuid,
        productName: name,
        noOfUnit,
      });
    });
  });

  return res;
};

//    if (type === ActionType.add) {
//      state.productSetItems = [...state.productSetItems, item];
//      state.advancedPriceSettings = state.advancedPriceSettings.map((i) => {
//        const { items }: any = i;
//        return {
//          ...i,
//          items: [
//            ...items,
//            {
//              unitPrice: 0,
//              productUuid: itemUuid,
//              productName: name,
//              noOfUnit,
//            },
//          ],
//        };
//      });
//    }
